import React from 'react';

const About = () => {
  return (
    <div className="about-return">
      <div id="about-container">
        <p id="about-title">ABOUT US</p>
        <p>Since opening in 2020, Delavega Autoplex has been proud to serve the RGV community. We’re committed to not only providing quality vehicles and service, but going above and beyond to ensure our customers are completely satisfied. We welcome you to look through our site to see all we have to offer.</p>
      </div>
    </div>

  )
}

export default About;